import { useEffect } from 'react';
import { useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles(() => ({
    smsCodeVerification: {
        margin: "0px auto 0 auto",
        width: "auto",
        height: "auto",
        textAlign: "center",
        direction: "ltr",
        borderRadius: 5,
        fontSize: 20,
        "& input": {
            border: "1px solid #e1e1e1",
            fontSize: "20px !important",
            height: 50,
            textAlign: "center",
            width: 50,
            borderRadius: 5,
            margin: 5,

            "@media(max-width : 1220px)": {
                width: 45,
                margin: 3,
            },
            "@media(max-width : 950px)": {
                width: 50,
                margin: 3,
            },
            "@media(max-width : 420px)": {
                width: 45,
                margin: 3,
            },
            '&[type=number]': {
                MozAppearance: 'textfield'
            },
            '&[type=number]::-webkit-outer-spin-button': {
                WebkitAppearance: 'none',
                margin: 0
            },
            '&[type=number]::-webkit-inner-spin-button': {
                '-webkit-appearance': 'none',
                margin: 0
            },

            "&:focus": {
                border: "1px solid #0B1742",
                fontSize: 20,
                outline: 0,
            },
            "&::placeholder": {
                color: "black",
                position: "relative",
                top: -5
            }
        }
    },
    root: {
        width: '100%'
    },
    textError: {
        color: '#E60001',
        fontSize: 12,
        fontWeight: 400,
    }
}))



export default function Otp({ InputSmsCode, setInputSmsCode, numberOtp, submiting, formikCustom }) {

    const classes = useStyles()
    const refOneNode = useRef()

    const handelSmsCode = () => {
        const form = document.querySelector('[name="verifyForm"]');
        const inputs = form.querySelectorAll(".inputs input");

        const formData = new FormData();

        function shouldSubmit() {
            return [...inputs].every((input) => input.value.length > 0);
        }

        function handleSubmit(e) {
            e.preventDefault();
            if (shouldSubmit()) {
                submiting()
            }
        }

        function handleInput(e) {
            const input = e.target;
            if (input.value) {
                formData.append(input.name, input.value);

                if (input.nextElementSibling) {
                    input.nextElementSibling.focus();
                }
            }
        }

        function handleFocus(e) {
            if (e.target.value) {
                e.target.select();
            }
        }

        function handlePaste(e) {
            const paste = e.clipboardData.getData("text");
            inputs.forEach((input, i) => {
                input.value = paste[i] || "";
                formData.set(input.name, input.value);
            });

            if (shouldSubmit()) {
                handleSubmit();
            }
        }

        function handleKeyDown(e) {
            if (e.key === "Backspace") {
                e.preventDefault();
                const target = e.target;
                const previousInput = target.previousElementSibling;

                if (target.value.length === 0 && previousInput) {
                    previousInput.focus();
                    previousInput.value = previousInput.value.slice(0, -1);
                    formData.set(previousInput.name, previousInput.value);
                } else {
                    target.value = target.value.slice(0, -1);
                    formData.set(target.name, target.value);
                }

                setInputSmsCode((prevState) => ({
                    ...prevState,
                    [target?.name?.[1]]: "",
                }));


            }
        }

        inputs[0].addEventListener("paste", handlePaste);

        form.addEventListener("input", handleInput);
        form.addEventListener("focusin", handleFocus);
        form.addEventListener("keydown", handleKeyDown);
        form.onsubmit = handleSubmit;
    };

    const handleChangeSmsCodeInput = (value, type) => {
        if (value === " " || value === "") {
            setInputSmsCode(() => ({
                1: "",
                2: "",
                3: "",
                4: "",
                5: "",
                6: "",
            }));
        } else {
            let valueInput = value.toString()
            setInputSmsCode((prev) => ({
                ...prev,
                [type]: valueInput?.length >= 2 ? valueInput[valueInput?.length - 1] : valueInput
            }));
        }
    };


    useEffect(() => {
        const combinedValues = Object.values(InputSmsCode).join("");
        let setFieldValue = formikCustom?.setFieldValue
        setFieldValue(`${formikCustom?.key}`, combinedValues)
        return () => { };
    }, [InputSmsCode]);


    return (
        <section className={classes.smsCodeVerification}>
            <div className={classes['root']} >
                <form name="verifyForm" onClick={() => handelSmsCode()}>
                    <div className="inputs d-flex justify-content-center align-content-center w-100" style={{ direction: 'ltr', maxWidth: '98%' }}>
                        <input
                            type='number'
                            inputMode='numeric'
                            name="n1"
                            maxLength={1}
                            className="border-red-400"
                            value={InputSmsCode["1"]}
                            onChange={(e) => handleChangeSmsCodeInput(e.target.value, 1)}
                            ref={refOneNode}
                            autoComplete="off"
                        />
                        <input
                            type='number'
                            inputMode='numeric'
                            name="n2"
                            maxLength={1}
                            value={InputSmsCode["2"]}
                            onChange={(e) => handleChangeSmsCodeInput(e.target.value, 2)}
                            autoComplete="off"
                        />
                        <input
                            type='number'
                            inputMode='numeric'
                            name="n3"
                            maxLength={1}
                            value={InputSmsCode["3"]}
                            onChange={(e) => handleChangeSmsCodeInput(e.target.value, 3)}
                            autoComplete="off"
                        />
                        <input
                            type='number'
                            inputMode='numeric'
                            name="n4"
                            maxLength={1}
                            value={InputSmsCode["4"]}
                            onChange={(e) => handleChangeSmsCodeInput(e.target.value, 4)}
                            autoComplete="off"
                        />
                        {
                            numberOtp > 4 && (
                                <input
                                    type='number'
                                    inputMode='numeric'
                                    name="n5"
                                    maxLength={1}
                                    value={InputSmsCode["5"]}
                                    onChange={(e) => handleChangeSmsCodeInput(e.target.value, 5)}
                                    autoComplete="off"
                                />

                            )
                        }
                        {
                            numberOtp === 6 && (
                                <input
                                    type='number'
                                    inputMode='numeric'
                                    name="n6"
                                    maxLength={1}
                                    value={InputSmsCode["6"]}
                                    onChange={(e) => handleChangeSmsCodeInput(e.target.value, 6)}
                                    autoComplete="off"

                                />
                            )
                        }
                    </div>
                    <button style={{ display: 'none' }} type="submit"></button>
                </form>

                <div>
                    {
                        formikCustom?.errors?.[formikCustom?.key] && formikCustom?.touched?.[formikCustom?.key] ? (
                            <span className={classes['textError']} style={{ color: 'red' }}>{formikCustom?.errors?.[formikCustom?.key]}</span>
                        ) : null
                    }
                </div>


            </div>
        </section>
    )
}
